import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRedo(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M13 17.205V13.92c-4.17 0-6.915 1.275-9 4.08.84-4.005 3.165-7.995 9-8.805V6l6 5.595-6 5.61Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
